import ReactDom from "react-dom";
import OutsideAlerter from "../../hooks/OutClickNotifier";
import { Modal as MantineModal } from "@mantine/core"

type ModalParams = {
   RootEl?: HTMLElement
   modalId?: string;
   handleClose?: Function;
   title?: any;
   children?: any;
   large?: boolean;
   header?: any;
   footer?: any;
   className?: string;
   size?:any
};

function Modal({ modalId, handleClose, children, header, footer, large, className, ...rest }: ModalParams) {
   return <MantineModal.Root size={rest.size||"lg"} closeOnClickOutside={false} closeOnEscape={false} className="modal-main" onClose={() => handleClose && handleClose()} opened={true}>
      <MantineModal.Overlay />
      <MantineModal.Content>
         <MantineModal.Header>
            <MantineModal.Title>{header && <div className='modal-header'>{header}</div>}</MantineModal.Title>
            <MantineModal.CloseButton />
         </MantineModal.Header>
         <MantineModal.Body>
            <div className='modal-content'>{children}</div>
            {footer && <div className='modal-footer'>{footer}</div>}
         </MantineModal.Body>
      </MantineModal.Content>
   </MantineModal.Root>
}

export default Modal;
